export default "https://cdn-static.gokick.com/assets/3eb3f200054f2a6c9c5d0f37afa2d1dee3c44d6a/images/tangerine-flavor.1fe86552bc4a40407da21340599dcac8.png";